module.exports = __webpack_public_path__ + "static/img/1-3.2c3cd4d9.png";